import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, makeStyles, Snackbar, Tab, Tabs, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useHistory } from 'react-router-dom'

import AccountDialog from '../lib/AccountDialog'
import UsersListView from '../../UsersListView'
import observApi from '../../../lib/observable-api'
import RoleManager from './RoleManager'
import queryString from '../../../utils/QueryString'
import RestrictedComponent, {
  hasPermission,
} from '../../../lib/components/form/RestrictedComponent'
import { getHasRequestError, getHasRequestPending } from '../../../redux/data/selectors'
import schema from '../../../routes/permissions/schema'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  createButton: {
    margin: '1rem',
  },
  searchFilter: {
    padding: '1rem',
  },
}))

const UserTab = (props) => {
  const { onCreate, clientID, onDeleteUser, onEditAccount } = props

  const [createDialog, setCreateDialog] = useState(false)
  const [filter, setFilter] = useState('')
  const [showCreateSnackbar, setShowCreateSnackbar] = useState(false)
  const [showDeleteSnackbar, setShowDeleteSnackbar] = useState(false)
  const classes = useStyles()

  const requestCreatePending = useSelector((state) =>
    getHasRequestPending(state, 'API_REQUEST_users_add')
  )
  const requestCreateError = useSelector((state) =>
    getHasRequestError(state, 'API_REQUEST_users_add')
  )

  let createSnackMessage = requestCreatePending ? 'Creating User' : 'Created User'
  if (requestCreateError) {
    createSnackMessage = 'Error' + requestCreateError
  }
  useEffect(() => {
    if (requestCreatePending || requestCreateError) {
      setShowCreateSnackbar(true)
    }
  }, [requestCreatePending, requestCreateError])
  const handleCloseCreateSnackbar = () => setShowCreateSnackbar(false)

  const requestDeletePending = useSelector((state) =>
    getHasRequestPending(state, 'API_REQUEST_users_delete')
  )
  const requestDeleteError = useSelector((state) =>
    getHasRequestError(state, 'API_REQUEST_users_delete')
  )

  let deleteSnackMessage = requestDeletePending ? 'Deleting User' : 'Deleted User'
  if (requestDeleteError) {
    deleteSnackMessage = 'Error' + requestDeleteError
  }
  useEffect(() => {
    if (requestDeletePending || requestDeleteError) {
      setShowDeleteSnackbar(true)
    }
  }, [requestDeletePending, requestDeleteError])
  const handleCloseDeleteSnackbar = () => setShowDeleteSnackbar(false)

  return (
    <>
      <Snackbar
        open={showCreateSnackbar}
        autoHideDuration={15000}
        onClose={handleCloseCreateSnackbar}
      >
        <Alert
          onClose={handleCloseCreateSnackbar}
          severity={requestCreateError ? 'error' : requestCreatePending ? 'info' : 'success'}
        >
          {createSnackMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showDeleteSnackbar}
        autoHideDuration={15000}
        onClose={handleCloseDeleteSnackbar}
      >
        <Alert
          onClose={handleCloseDeleteSnackbar}
          severity={requestDeleteError ? 'error' : requestDeletePending ? 'info' : 'success'}
        >
          {deleteSnackMessage}
        </Alert>
      </Snackbar>
      <div>
        <TextField
          size='small'
          className={classes.searchFilter}
          placeholder='Search'
          // label="Search"
          variant='outlined'
          value={filter}
          onChange={(ev) => setFilter(ev.target.value)}
        />
        <RestrictedComponent permissionCheck={schema.ACCOUNT.ANY_CREATE}>
          <Button
            className={classes.createButton}
            variant='contained'
            color='primary'
            onClick={() => setCreateDialog(true)}
          >
            Create User
          </Button>
        </RestrictedComponent>
      </div>
      <AccountDialog
        onSubmit={onCreate}
        onClose={() => setCreateDialog(false)}
        isOpen={createDialog}
        clientID={clientID}
      />
      <UsersListView onDelete={onDeleteUser} onEditAccount={onEditAccount} searchFilter={filter} />
    </>
  )
}

const SecurityGroupManager = (props) => {
  const { api } = props
  const classes = useStyles()

  const accountApi = observApi(api.users)
  const onDeleteUser = accountApi.actions.delete
  const onEditAccount = accountApi.actions.edit
  const onCreateUser = accountApi.actions.add

  const clientID = useSelector((state) => state.data.user.clientId)
  const history = useHistory()
  const qs = queryString.parse(location.search)
  let qsTab = parseInt(qs.tab)
  if (isNaN(qsTab) || qsTab === null || qsTab === undefined) {
    qsTab = 0
  }
  const [tab, setTab] = useState(qsTab)
  const hasSecurityRolePermission = hasPermission(schema.ACCOUNT_SECURITY_GROUPS.READ)

  if (tab === 1 && !hasSecurityRolePermission) {
    setTab(0)
    queryString.set({ ...qs, tab: 0 })
    history.push('/securityGroups?tab=0')
  }
  let renderTab
  switch (tab) {
    case 0:
      renderTab = (
        <UserTab
          onCreate={onCreateUser}
          clientID={clientID}
          onDeleteUser={onDeleteUser}
          onEditAccount={onEditAccount}
        />
      )
      break
    case 1:
      renderTab = <RoleManager />
      break
  }

  return (
    <div className='panel panel-default'>
      <div className='panel-heading'>
        <div className={'panel-title'}>
          <Tabs
            value={tab}
            onChange={(ev, value) => {
              setTab(value)
              queryString.set({ ...queryString.parse(location.search), tab: value })
              history.push('/securityGroups?tab=' + value)
            }}
          >
            <Tab label='Users' />
            {hasSecurityRolePermission ? (
              <Tab label='Security Roles' />
            ) : (
              <RestrictedComponent permissionCheck={false}>
                <Tab label='Security Roles' />
              </RestrictedComponent>
            )}
          </Tabs>
        </div>
      </div>
      {renderTab}
    </div>
  )
}

export default SecurityGroupManager
